module.exports = __webpack_public_path__ + "img/collection-diamondJewelryDelicateJewels@2x.8038f0d.webp";